import {useDebugValue, useState} from 'react';

import {useInitialization} from '../../../hooks/useInitialization';

import {getSearchCookies} from '../../../utils/cookies';

const initialSearchCookies = {
    destinationValues: {},
    datesValues: {},
    guestsValues: {}
};

function useSearchCookies() {
    const [
        searchCookies,
        setSearchCookies
    ] = useState(initialSearchCookies);

    function updateSearchCookies(nextSearchCookies) {
        setSearchCookies(nextSearchCookies);
    }

    useInitialization(function initializeSearchCookies() {
        updateSearchCookies(getSearchCookies());
    });

    const result = {
        searchCookies,
        setSearchCookies
    };

    useDebugValue(result);

    return result;
}

export {useSearchCookies};
